import { InspectFileState } from 'types';

export default function getFileName(file: InspectFileState) {
  const fileName = file.fileName.length > 100 ? `${file.fileName.substring(0, 100)}...` : file.fileName;
  const originalName = file.originalName.length > 100 ? `${file.originalName.substring(0, 100)}...` : file.originalName;
  const name = file.originalName.length > 0 ? originalName : fileName;
  return name;
}
